import {
    Component, OnInit, ViewChild, Inject
} from '@angular/core';
import { ProjectManagementService } from 'app/services/project-management.service';
import { DataService } from 'app/services/data.service';
import { FrontEndService } from 'app/services/front-end.service';
import { NgbTabset, NgbTab } from '@ng-bootstrap/ng-bootstrap';
import { StateService} from '@uirouter/angular';
import { Transition } from '@uirouter/angular';
import { Observable } from "rxjs/Rx";
import "styles/app.scss";
import { DOCUMENT } from '@angular/platform-browser';

import { LogService } from "app/services/log.service";
import {UserManagementService} from "../../services/user-management.service";

@Component({
    selector: 'app-project-wall',
    providers: [NgbTabset, NgbTab],
    templateUrl: './project-wall.component.html',
    styleUrls: ['./project-wall.component.scss'],
})
export class ProjectWallComponent implements OnInit {

    @ViewChild('tabs') tabs;
    @ViewChild('attachmentsTab') attachmentsTab;

    data: string;
    project_id: string;
    post_id: string;
    currentState: string;
    fip_id = null;
    file_offset = 0;

    activeTab = 'wall';
    selected_project = {};

    project_details_flag = true;
    isProjectAccessible = false;
    loading = false;
    project_status = "";
    project_active = true;
    project_owner = "";
    current_user_profile;
    current_user_role;
    current_username;

    users = {};
    usersLoaded = false;

    wait_timer = Observable.timer(0, 1000);
    wait_timer_subscription: any;

    constructor(
        @Inject(DOCUMENT) private document: Document,
        private project_management_service: ProjectManagementService,
        private ngbTabset: NgbTabset,
        public dataService: DataService,
        public front_end_service: FrontEndService,
        private userManagementService: UserManagementService,
        private stateService: StateService,
        private transition: Transition,
        private logService: LogService
    ) {
    }

    ngOnInit() {
        this.getUsers();
        this.current_user_profile = JSON.parse(localStorage.getItem('currentUserProfile'));

        if(this.current_user_profile != null || this.current_user_profile !== undefined) {
            this.current_user_role = JSON.parse(localStorage.getItem('currentUserProfile')).role;
            this.current_username = JSON.parse(localStorage.getItem('currentUserProfile')).username;
        }

        this.logService.printLog('Project Status : ' + this.project_status);
        this.file_offset = 0;

        this.currentState = this.stateService.current.name;

        this.logService.printLog("Project id - " + this.transition.params().project_id, "");
        if (this.transition.params().project_id !== "" && this.transition.params().project_id !== undefined) {
            if (this.dataService.selected_project !== +this.transition.params().project_id) {
                this.dataService.selected_project = +this.transition.params().project_id;
                this.loading = true;

                // if project has changed then remove old walls
                this.dataService.wall_files_list = [];
                this.dataService.wall_list = [];
            }
        }

        if (this.currentState === "project") {
            this.logService.printLog("State - Project, ID - " + this.project_id);
        } else if (this.currentState === "projectWall") {
            if (this.transition.params().post_id !== '') {
                this.post_id = this.transition.params().post_id;
            }
        } else if (this.currentState === "projectAttachments") {
            this.activeTab = "attachments";
        } else if (this.currentState === "projectUsers") {
            this.activeTab = "users";
        } else if (this.currentState === "projectDetails") {
            this.activeTab = "details";
        } else if (this.currentState === "projectChats") {
            this.activeTab = "chats";
            if (this.transition.params().user_id !== "" && this.transition.params().user_id !== undefined) {
            }
        } else if (this.currentState === "projectEvaluationTab") {
            this.activeTab = "evaluation";
        }

        this.wait_timer_subscription = this.wait_timer.subscribe(() => {
            if (this.project_details_flag) {
                this.wait_for_project_details("Local");
            }
        });
    }

    wait_for_project_details(event) {
        this.dataService.projectListObservable.subscribe(() => {
            const temp = this.dataService.get_array_details(
                this.dataService.project_list,
                "fip_id",
                this.dataService.selected_project
            );

            if (temp !== undefined) {
                if (temp.hasOwnProperty('title') && temp['title'] !== undefined) {
                    this.project_details_flag = false;
                    this.loading = false;
                    this.selected_project = temp;
                    this.logService.printLog("selected_project", this.selected_project);

                    this.wait_timer_subscription.unsubscribe();

                    this.project_status = temp['status'];
                    this.project_active = temp['isActive'];
                    this.project_owner = temp['owner'].username;

                    this.projectAccess();
                }
            }
        });
    }

    /**
     * Tab changed listener, to change the state and url when tab is changed
     * @param event
     */
    tabChanged (event) {
        let state = "";
        if (event.nextId !== 'wall') {
            state = `/${event.nextId}`;
        }
        const url = `project/${this.dataService.selected_project}${state}`;
        window.history.pushState({}, null, url);
    }

    projectAccess() {
        this.isProjectAccessible = true;
    }

    download_file = (project_id, file_id, file_name, file_type) => {
        const full_file_name = file_name + file_type;
        this.project_management_service.download_file(project_id, file_id, full_file_name,(resp) => {});
    };

    deleteFile = (projectId, fileId, isDelete: boolean) => {
        let message = 'restore_file_confirmation';
        if (isDelete) {
            message = 'delete_file_confirmation';
        }
        this.front_end_service.confirmAlert('confirm', message, 'warning', (result) => {
            if (result.value) {
                this.project_management_service.deleteFile(fileId, this.dataService.selected_project, (response) => {
                    if (response.status) {
                        this.dataService.wall_files_list.forEach((file) => {
                            if (file.id === fileId) {
                                let successMessage = "file_restored_successfully";
                                if (isDelete) {
                                    successMessage = "file_deleted_successfully";
                                }
                                this.front_end_service.addToast("success", successMessage, "success");
                                file.is_active = !file.is_active;
                            }
                        });
                    }
                });
            }
        });
    };

    getUsers() {
        this.usersLoaded = false;
        this.userManagementService.userList((userResponse) => {
            if (userResponse.status) {
                this.users = [];
                userResponse.data.forEach((user) => {
                    this.users[user.id] = user;
                });
                this.usersLoaded = true;
            }
        });
    }
}
